// extracted by mini-css-extract-plugin
module.exports = {"logo_box":"logo_box-3L9M7H81","logo_main":"logo_main-t_iV-Bte","logo_link":"logo_link-3Yyxtk5Q","time":"time-2XRcIplG"};